import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * 달력 상단의 연/월 이동용 헤더 컴포넌트.
 */
const CalendarHeader = ({ viewDate, onPrev, onNext }) => {
    return (
        <div className="flex justify-between items-center mb-3 px-1" style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
            <button onClick={onPrev} className="p-1.5 hover:bg-gray-100 rounded-xl transition-colors">
                <ChevronLeft size={16} className="text-gray-400" />
            </button>
            <div className="text-[13px] font-black text-gray-800">
                {viewDate.getFullYear()}년 {viewDate.getMonth() + 1}월
            </div>
            <button onClick={onNext} className="p-1.5 hover:bg-gray-100 rounded-xl transition-colors">
                <ChevronRight size={16} className="text-gray-400" />
            </button>
        </div>
    );
};

export default CalendarHeader;
